import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.components.WorkflowWizardPopup.RequestersStep', {
    title: 'Select the Requesters',
    subtitle: 'Requesters are users authorised to create documents and submit them for approval in ApprovalMax.',
    allUsers: 'All users',
});
